// src/pages/Login.js
import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Alert, Image } from "react-bootstrap";
import { AuthContext } from "../contexts/AuthContext";
import "./Login.css";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const { login, currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Realtime Maintenance";
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.overflow = "hidden";

    if (currentUser) {
      redirectBasedOnRole(currentUser.role);
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.margin = "";
      document.body.style.padding = "";
    };
  }, [currentUser]);

  const redirectBasedOnRole = (role) => {
    switch (role) {
      case "user":
        navigate("/user-dashboard");
        break;
      case "maintenance":
        navigate("/maintenance-dashboard");
        break;
      case "teknisi":
        navigate("/teknisi-dashboard");
        break;
      case "admin":
        navigate("/admin-dashboard");
        break;
      default:
        navigate("/dashboard");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setLoading(true);

    try {
      const result = await login(username, password);

      if (result.success) {
        redirectBasedOnRole(result.role);
      } else {
        setError(result.error || "Username atau password salah");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Gagal terhubung ke server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="login-container"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/img/bg.jpeg)`,
      }}
    >
      {/* Card login */}
      <div
        className="login-card"
        style={{ marginTop: "30px", paddingTop: "40px" }}
      >
        <div className="login-header">
          <div className="top-logo-left">
            <Image
              src="/img/PT_CABLE_TECH.png"
              alt="Cable Tech"
              className="login-logo"
            />
          </div>

          <div className="top-logo-right">
            <Image
              src="/img/mtc.png"
              alt="Maintenance"
              className="login-logo"
            />
          </div>

          <h2 className="login-title">LOGIN</h2>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <Button type="submit" disabled={loading} className="login-button">
            {loading ? "Memproses..." : "LOGIN"}
          </Button>
        </form>
      </div>

      <div className="login-footer">
        © {new Date().getFullYear()} PT Cable Tech
      </div>
    </div>
  );
};

export default Login;
